export class SegmentMesh {
  id: number;
  l: number;
  l0: number;
  l1: number;
}
